import React, { Fragment } from 'react';
import { Button, Card, Col, Form, Modal, Row, Container } from 'react-bootstrap';
import { formato_monto } from '../../common/Formatos';


const DetallePagoEmitido = ({ showDetalle, setShowDetalle, cfg_form, medioPago }) => (
    <Fragment>
        <Modal show={showDetalle} onHide={() => setShowDetalle(false)} size='xl'>
            <Card>
                <Card.Header className='cardHeader'>
                    {cfg_form && cfg_form['modalconsultapagosemitidos-detalle-title']}
                </Card.Header>

                <Card.Body>
                    <Container>
                        <Row>
                            <Col md='3' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-tipopago"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.TipoPago}
                                </Form.Text>
                            </Col>
                            <Col md='3' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-implicado"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.Implicado}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-dest"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.DestinatarioPago}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-boleta"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.NumBoletaFact}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-fechadocto"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.FechaBoletaFactFormato}
                                </Form.Text>
                            </Col>

                            <Col md='3' className='mb-4'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-cober"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.Cobertura}
                                </Form.Text>
                            </Col>
                            <Col md='3' className='mb-4'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-fecha"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.FechaPagoFormato}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-4'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-neto"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && formato_monto(medioPago.MontoNeto)}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-4'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-impto"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.Impuesto}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-4'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-bruto"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && formato_monto(medioPago.MontoBruto)}
                                </Form.Text>
                            </Col>

                            <hr style={{ borderTop: '2px solid #04005D' }}></hr>

                            <Col md='3' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-folio"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago?.Sidepag}
                                </Form.Text>
                            </Col>
                            <Col md='3' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-forma"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.FormaPago}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-medio"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.MedioPago}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-banco"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.Banco}
                                </Form.Text>
                            </Col>
                            <Col md='2' className='mb-2'>
                                <Form.Label className='label'>
                                    {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-cuenta"]}
                                </Form.Label>
                                <br />
                                <Form.Text>
                                    {medioPago && medioPago.NumCuenta}
                                </Form.Text>
                            </Col>
                        </Row>
                    </Container>
                </Card.Body>

                <Card.Footer style={{ display: 'flex', justifyContent: 'right' }}>
                    <Button className='m-2' variant='outline-info' onClick={() => setShowDetalle(false)}>
                        {cfg_form && cfg_form["modalconsultapagosemitidos-detalle-btn-volver"]}
                    </Button>
                </Card.Footer>
            </Card>
        </Modal>
        <style type='text/css'>
            {`
                .label {
                    font-weight: bold;
                    font-size: 14px;
                }
            `}
        </style>
    </Fragment>
)


export default DetallePagoEmitido;